/**
 * Warms the network connection to a cross-origin host by injecting idempotent
 * `preconnect` + `dns-prefetch` link tags. Used to speed up the Flow Viewer iframe
 * (a separate, slow-to-connect origin) by starting the TLS/DNS handshake early.
 *
 * No `crossorigin` attribute: iframe document loads are navigations (not CORS fetches),
 * and a crossorigin preconnect would open a separate socket the navigation can't reuse.
 */
export function preconnectOrigin(rawUrl) {
    if (!rawUrl || typeof document === 'undefined')
        return;
    let origin;
    try {
        const u = new URL(rawUrl, window.location.href);
        if (u.protocol !== 'http:' && u.protocol !== 'https:')
            return;
        origin = u.origin;
    }
    catch {
        return;
    }
    // Same-origin needs no warming.
    if (origin === window.location.origin)
        return;
    ensureLink('preconnect', origin);
    ensureLink('dns-prefetch', origin);
}
function ensureLink(rel, href) {
    const existing = document.head.querySelector(`link[rel="${rel}"][href="${href}"]`);
    if (existing)
        return;
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    document.head.appendChild(link);
}
